import { useCallback, useState, createContext } from 'react';
import { ToastContainer } from 'react-bootstrap';
import ToastComponent from '../../ntisui/Atoms/ToastComponent';
import { successIcon, failureIcon } from '../../../constants/Constants';
const ToastContext = createContext<any>({});

export default ToastContext;

export function ToastContextProvider(props: any) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback(
    function (toast) {
      setToasts((toasts) => [...toasts, toast]);
    },
    [setToasts],
  );

  return (
    <ToastContext.Provider value={addToast}>
      {props.children}
      <ToastContainer
        position="top-end"
        className="toast-container"
        data-testid="toast-container"
      >
        {toasts.map((toast) => (
          <ToastComponent
            autohide={true}
            className={toast.action === 'success' ? 'success' : 'failure'}
            delay={6000}
            icon={toast.action === 'success' ? successIcon : failureIcon}
            toastMessage={toast.message}
          />
        ))}
      </ToastContainer>
    </ToastContext.Provider>
  );
}
